import { render, staticRenderFns } from "./membershipList.vue?vue&type=template&id=006bd1e8&scoped=true"
import script from "./membershipList.vue?vue&type=script&lang=js"
export * from "./membershipList.vue?vue&type=script&lang=js"
import style0 from "./membershipList.vue?vue&type=style&index=0&id=006bd1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006bd1e8",
  null
  
)

export default component.exports